import * as React from 'react';
const SendOffIcon = (props: any) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={12} cy={12} r={11.5} stroke="#B3B3B3" />
    <path
      d="M7.76465 10.5882L11.9999 5.64706L16.2352 10.5882"
      stroke="#B3B3B3"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.64706V18.3529"
      stroke="#B3B3B3"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SendOffIcon;
